import { useEffect, useState } from 'react';

const faqs = [
  {
    id: 1,
    question: "Quelle est la meilleure nourriture pour mon chien ou chat ?",
    answer: "La meilleure alimentation dépend de la race, de l'âge et de l'état de santé de votre animal. Chez Animalia, nous proposons une gamme complète de croquettes et de pâtées hypoallergéniques et équilibrées.",
  },
  {
    id: 2,
    question: "Quels produits recommandez-vous pour l'hygiène des animaux ?",
    answer: "Nous recommandons des shampoings doux, des lingettes nettoyantes et des produits antiparasitaires naturels pour garder votre animal propre et en bonne santé.",
  },
  {
    id: 3,
    question: "À quelle fréquence dois-je nourrir mon animal ?",
    answer: "Les chiens adultes mangent généralement deux fois par jour, tandis que les chats peuvent avoir plusieurs petits repas. Suivez les recommandations sur l'emballage ou demandez conseil à notre équipe.",
  },
  {
    id: 4,
    question: "Proposez-vous des produits pour animaux exotiques ?",
    answer: "Oui ! Nous avons une sélection dédiée aux NAC (nouveaux animaux de compagnie) : rongeurs, reptiles, oiseaux et plus encore. Contactez-nous pour des conseils personnalisés.",
  },
];

export default function Faq() {
  const [openId, setOpenId] = useState(1);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const check = () => setIsMobile(window.innerWidth <= 768);
    check();
    window.addEventListener('resize', check);
    return () => window.removeEventListener('resize', check);
  }, []);

  const toggle = (id) => setOpenId(openId === id ? null : id);

  return (
    <>
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Playfair+Display:wght@700&family=DM+Sans:wght@400;500&display=swap');

        .faq-section {
          background: #d5e6eb;
          padding: ${isMobile ? '50px 0' : '80px 0'};
          font-family: 'DM Sans', sans-serif;
        }

        .faq-inner {
          max-width: 1100px;
          margin: 0 auto;
          padding: 0 24px;
          display: flex;
          gap: ${isMobile ? '0' : '60px'};
          align-items: flex-start;
          flex-direction: ${isMobile ? 'column' : 'row'};
        }

        /* LEFT COLUMN */
        .faq-left {
          flex: 0 0 ${isMobile ? '100%' : '340px'};
          width: ${isMobile ? '100%' : '340px'};
          margin-bottom: ${isMobile ? '36px' : '0'};
          position: sticky;
          top: 80px;
        }

        .faq-label {
          font-size: 13px;
          font-weight: 600;
          letter-spacing: 2px;
          text-transform: uppercase;
          color: #ff41b4;
          margin-bottom: 12px;
        }

        .faq-heading {
          font-size: ${isMobile ? '28px' : '36px'};
          font-weight: 700;
          color: #0a303a;
          line-height: 1.25;
          margin: 0 0 20px 0;
        }

        .faq-desc {
          font-size: 15px;
          color: #4a6a74;
          line-height: 1.7;
          margin: 0 0 32px 0;
        }

        .faq-image-card {
          border-radius: 20px;
          overflow: hidden;
          position: relative;
          background: #0a303a;
          height: 200px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .faq-image-card img {
          width: 100%;
          height: 100%;
          object-fit: cover;
          opacity: 0.75;
          border-radius: 20px;
        }

        .faq-image-badge {
          position: absolute;
          bottom: 16px;
          left: 16px;
          background: #ff41b4;
          color: white;
          font-size: 12px;
          font-weight: 600;
          padding: 6px 14px;
          border-radius: 100px;
          letter-spacing: 0.5px;
        }

        /* RIGHT COLUMN */
        .faq-right {
          flex: 1;
        }

        .faq-item {
          background: #fff;
          border-radius: 14px;
          margin-bottom: 10px;
          overflow: hidden;
          transition: box-shadow 0.2s ease;
        }

        .faq-item:last-child {
          margin-bottom: 0;
        }

        .faq-item.open {
          box-shadow: 0 4px 20px rgba(10, 48, 58, 0.10);
        }

        .faq-question {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding: 18px 22px;
          cursor: pointer;
          gap: 16px;
          user-select: none;
        }

        .faq-question-text {
          font-size: 15px;
          font-weight: 600;
          color: #0a303a;
          line-height: 1.4;
          flex: 1;
        }

        .faq-icon {
          flex-shrink: 0;
          width: 32px;
          height: 32px;
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 20px;
          font-weight: 700;
          line-height: 1;
          transition: background 0.2s, color 0.2s, transform 0.3s;
        }
.faq-image-card {
  position: relative;
  width: 100%;
  max-width: 500px;
  margin: auto;
}

.faq-tv-frame {
  width: 100%;
  display: block;
  position: relative;
  z-index: 1;
  margin-bottom: -280px; /* Adjust this value to position the inner image correctly */
}

.faq-inner-image {
  position: absolute;
  top: 15%;        /* adjust vertical position */
  left: 5%;        /* adjust horizontal position */
  width: 29%;      /* bigger so you can see it */
  height: 10%;    /* maintain aspect ratio */
  object-fit: contain;
  border-radius: 8px;
  z-index: 2;
}


.faq-image-badge {
  position: absolute;
  bottom: 20px;
  left: 20px;
  background: #ff41b4;
  color: #fff;
  padding: 8px 14px;
  font-size: 14px;
  font-weight: 600;
  border-radius: 20px;
  z-index: 3;
}

        .faq-icon.open {
          background: #ff41b4;
          color: white;
          transform: rotate(45deg);
        }

        .faq-icon.closed {
          background: #d5e6eb;
          color: #ff41b4;
          transform: rotate(0deg);
        }

        .faq-answer {
          max-height: 0;
          overflow: hidden;
          transition: max-height 0.35s ease, padding 0.35s ease;
          padding: 0 22px;
        }

        .faq-answer.open {
          max-height: 300px;
          padding: 0 22px 18px;
        }

        .faq-answer-text {
          font-size: 14px;
          color: #4a6a74;
          line-height: 1.75;
          border-top: 1px solid #eef5f7;
          padding-top: 14px;
        }
      `}</style>

      <section className="faq-section">
        <div className="faq-inner">

          {/* LEFT */}
          <div className="faq-left">
            <p className="faq-label">Questions fréquentes</p>
            <h2 className="faq-heading">Alimentation & Hygiène pour Chiens et Chats</h2>
            <p className="faq-desc">
              Tout ce que vous devez savoir pour garder votre compagnon heureux, en bonne santé et bien nourri.
            </p>
            <div className="faq-image-card">
              <img
                src="img/images/faq_tv.png"
                alt="TV Frame"
                className="faq-tv-frame"
              />

              <img
                src="/img/images/breeder_img043.png"
                alt="Breeder"

              />

              <span className="faq-image-badge">🐾 Conseils experts</span>
            </div>

          </div>

          {/* RIGHT */}
          <div className="faq-right">
            {faqs.map((faq) => {
              const isOpen = openId === faq.id;
              return (
                <div key={faq.id} className={`faq-item ${isOpen ? 'open' : ''}`}>
                  <div className="faq-question" onClick={() => toggle(faq.id)}>
                    <span className="faq-question-text">{faq.question}</span>
                    <span className={`faq-icon ${isOpen ? 'open' : 'closed'}`}>+</span>
                  </div>
                  <div className={`faq-answer ${isOpen ? 'open' : ''}`}>
                    <p className="faq-answer-text">{faq.answer}</p>
                  </div>
                </div>
              );
            })}
          </div>

        </div>
      </section>
    </>
  );
}